module.exports = __webpack_public_path__ + "static/media/1 15 ogsa.b3170cef.mp3";